import { Component, OnInit, EventEmitter } from '@angular/core';


import { FlatfileService } from '../../services/flatfile.service';

import { ActivatedRoute } from '@angular/router';
import { UploadOutput, UploadInput, UploadFile, humanizeBytes, UploaderOptions } from 'ngx-uploader';
import { environment } from '../../../environments/environment';
import { Sharedservice } from './../../shared-components/shared.service';
import { InfraService } from 'src/app/services/infra.service';
import { ErrorPopUpModel } from 'src/app/models/errorpopup.model';
import { LanguageConstants } from 'src/app/shared-components/constant';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Component({
  selector: 'app-flatfile',
  templateUrl: './flatfile.component.html',
  styleUrls: ['./flatfile.component.css']
})

export class FlatfileComponent implements OnInit {
  engagementId = +this.route.snapshot.paramMap.get('id');
  options: UploaderOptions;
  formData: FormData;
  sourceFiles: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;
  errorModel: ErrorPopUpModel = new ErrorPopUpModel();
  private configUrl: string;
  langCode: string;
  currLangTranslation: any;
  constructor(private infraService: InfraService, private flatfile: FlatfileService, private route: ActivatedRoute,
    private sharedService: Sharedservice, private translateService: TranslateService) {

    // if (localStorage.getItem('selectedregion') == '1') {
    // this.configUrl = environment.apiUrl + 'filedownload/flatfile/' + this.engagementId;
    // }
    // else {
    //  this.configUrl = environment.apiUrlRow + 'filedownload/flatfile/' + this.engagementId;
    // }

    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1 + 'filedownload/flatfile/' + this.engagementId;
    });

    this.options = {
      concurrency: 1, maxUploads: 1, allowedContentTypes: [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel.sheet.macroEnabled.12'] };
    this.sourceFiles = []; // local uploading files array
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;
  }

  public ExportExcel: any[] = [];
  ngOnInit() {
    this.sharedService.CheckUserAccessForEngagement(this.engagementId);
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
    });
  }

  Downloadclick(event:any) {
    event.stopPropagation();
    window.location.href = this.configUrl;
  }

  onUploadOutput(output: UploadOutput): void {
    if (output.type === 'allAddedToQueue') { // when all files added in queue
      // uncomment this if you want to auto upload files when added
      const event: UploadInput = {
        type: 'uploadFile',
        url: this.configUrl,
        method: 'POST',
        data: { foo: 'bar' }
        , headers: { 'Authorization': 'Bearer ' + (environment.isBearerAuthorizationEnabled ? localStorage['dbamsaltoken']
         : environment.sampleToken) }
      };
      this.uploadInput.emit(event);
    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') { // add file to array when added
      this.sourceFiles.push(output.file);
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      // update current data in files array for uploading file
      const index = this.sourceFiles.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.sourceFiles[index] = output.file;
    } else if (output.type === 'rejected' && typeof output.file !== 'undefined') {
      this.errorModel.confirmIsDisplay = true;
      this.errorModel.displayMessage = this.currLangTranslation.uploadSourcefilemessage.errorMessage.FormateError;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.sourceFiles = this.sourceFiles.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
  }

  // startUpload(): void {
  //  const event: UploadInput = {
  //    type: 'uploadAll',
  //    url: 'http://ngx-uploader.com/upload',
  //    method: 'POST',
  //    data: { foo: 'bar' }
  //  };

  //  this.uploadInput.emit(event);
  // }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  removeFile(id: string): void {
    this.uploadInput.emit({ type: 'remove', id: id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({ type: 'removeAll' });
  }

  confirmdisplay = false;
  closeEventFlatFile($event) {
    this.confirmdisplay = $event;
  }
}

